module.exports = __webpack_public_path__ + "img/app-dne-download-ios.95fb630d.svg";